import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { RestService } from '../rest.service';
import { ErrorsService, CARREGAR, SALVAR, ATUALIZAR } from '../errors/errors.service';
import { URL_API } from 'src/app/tools/URL';

export interface UserMail {
  id: number | null;
  username: string | null;
  email: string | null;
}

export interface EmailUsuarioKCDto {
  id: number;
  username: string;
  email: string;
}

export interface EmailUsuarioKCRequest {
  username: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserMailService {

  constructor(private rest: RestService, private errorsService: ErrorsService) { }

  buscarEmail(username: string): Observable<UserMail> {
    const params = new HttpParams().set('username', username);
    return this.rest.get(URL_API.PATH_USUARIO_KC_EMAIL, params).pipe(
      retry(1),
      catchError(response => response && response.status === 500
        ? throwError(response)
        : this.errorsService.handleError(response, CARREGAR))
    );
  }

  buscarPorUsername(username: string): Observable<EmailUsuarioKCDto> {
    const path = URL_API.PATH_USUARIO_EMAIL_KC_POR_USERNAME + encodeURIComponent(username);
    console.log('Buscando e-mail por username:', username);
    console.log('Path:', path);
    return this.rest.get(path).pipe(
      retry(1),
      catchError(response => response && response.status === 404
        ? throwError('Nenhum registro de e-mail encontrado para o username informado.')
        : this.errorsService.handleApiError(response, CARREGAR))
    );
  }

  cadastrar(request: EmailUsuarioKCRequest): Observable<EmailUsuarioKCDto> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.rest.post(URL_API.PATH_USUARIO_EMAIL_KC, request, undefined, headers).pipe(
      catchError(response => this.errorsService.handleApiError(response, SALVAR))
    );
  }

  buscarPorId(id: number): Observable<EmailUsuarioKCDto> {
    return this.rest.get(URL_API.PATH_USUARIO_EMAIL_KC_POR_ID + encodeURIComponent(String(id))).pipe(
      retry(1),
      catchError(response => this.errorsService.handleApiError(response, CARREGAR))
    );
  }

  atualizar(id: number, request: EmailUsuarioKCRequest): Observable<EmailUsuarioKCDto> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.rest.put(
      URL_API.PATH_USUARIO_EMAIL_KC_POR_ID + encodeURIComponent(String(id)),
      request,
      undefined,
      headers
    ).pipe(
      catchError(response => this.errorsService.handleApiError(response, ATUALIZAR))
    );
  }

  remover(id: number): Observable<any> {
    return this.rest.delete(URL_API.PATH_USUARIO_EMAIL_KC_POR_ID + encodeURIComponent(String(id))).pipe(
      catchError(response => this.errorsService.handleApiError(response, ATUALIZAR))
    );
  }
}
